import { render, staticRenderFns } from "./editwidgets.vue?vue&type=template&id=9348b87c&"
import script from "./editwidgets.vue?vue&type=script&lang=js&"
export * from "./editwidgets.vue?vue&type=script&lang=js&"
import style0 from "./editwidgets.vue?vue&type=style&index=0&id=9348b87c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports